import {BRAND_ILLUSTRATION_2026_NAMES} from './brand-illustrations-2026-names';

export const BRAND_PATH_PREFIX = 'https://dam.malt.com/brand/';
export const BRAND_ILLUSTRATIONS_PATH_PREFIX = `${BRAND_PATH_PREFIX}illustrations/`;
export const BRAND_ILLUSTRATIONS_2026_PATH_PREFIX = `${BRAND_ILLUSTRATIONS_PATH_PREFIX}2026/`;

export {BRAND_ILLUSTRATION_2026_NAMES};

let readBrandIllustrations2026 = () => false;

export function setBrandIllustrations2026Reader(reader) {
    readBrandIllustrations2026 = reader;
}

const ALTERNATE_RASTER_EXTENSION = {png: 'svg', svg: 'png'};

function illustrationFileName(name) {
    const queryIndex = name.indexOf('?');
    return queryIndex === -1 ? name : name.slice(0, queryIndex);
}

function mappedName(fileName) {
    return BRAND_ILLUSTRATION_2026_NAMES[fileName] ?? BRAND_ILLUSTRATION_2026_NAMES[fileName.toLowerCase()];
}

function brandIllustration2026Name(fileName) {
    const exact = mappedName(fileName);
    if (exact) {
        return exact;
    }

    const dot = fileName.lastIndexOf('.');
    if (dot === -1) {
        return undefined;
    }

    const alternateExtension = ALTERNATE_RASTER_EXTENSION[fileName.slice(dot + 1).toLowerCase()];
    if (!alternateExtension) {
        return undefined;
    }

    return mappedName(`${fileName.slice(0, dot)}.${alternateExtension}`);
}

export function getBrandIllustration(name, use2026) {
    const enabled = use2026 ?? readBrandIllustrations2026();
    const renamed = enabled ? brandIllustration2026Name(illustrationFileName(name)) : undefined;
    if (!renamed) {
        return `${BRAND_ILLUSTRATIONS_PATH_PREFIX}${name}`;
    }
    return `${BRAND_ILLUSTRATIONS_2026_PATH_PREFIX}${renamed}`;
}
